export default "__VITE_ASSET__CPsfbjiz__"